import React, { useState, useEffect, Suspense, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import { settingsTabIndexFromSearch, settingsTabIdFromIndex } from '../../utils/settingsTabs';
import ProfileTab from './tabs/ProfileTab';
import PaymentMethodTab from './tabs/PaymentMethodTab';
import SecurityTab from './tabs/SecurityTab';
import ActivityTab from './tabs/ActivityTab';
import SubscriptionTab from './tabs/SubscriptionTab';

const OrganizationSettings = React.lazy(() => import('./OrganizationSettings'));
const TeamSettings = React.lazy(() => import('../Operations/OperationsTeamPage'));

const useStyles = makeStyles((theme) => ({
  shell: {
    marginLeft: 'var(--app-shell-offset, 92px)',
    marginTop: 88,
    padding: theme.spacing(2, 2, 4),
    maxWidth: 1100,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
    '& .MuiTab-root': {
      minHeight: 48,
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.9375rem',
    },
  },
}));

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <div className="settings-tab-panel">{children}</div>;
}

const Settings = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [tab, setTab] = useState(() => settingsTabIndexFromSearch(location.search));

  useEffect(() => {
    const idx = settingsTabIndexFromSearch(location.search);
    setTab(idx);
  }, [location.search]);

  const onTabChange = useCallback(
    (_, newIndex) => {
      setTab(newIndex);
      const id = settingsTabIdFromIndex(newIndex);
      history.replace({ pathname: '/settings-profile', search: `?tab=${id}` });
    },
    [history]
  );

  return (
    <div className="content-body">
      <div className={classes.shell}>
        <div className="container" style={{ maxWidth: '100%' }}>
          <div className="row">
            <div className="col-12">
              <div className="page-title">
                <h4>Settings</h4>
              </div>
              <div className="card">
                <div className="card-body">
                  <Tabs
                    value={tab}
                    onChange={onTabChange}
                    className={classes.tabs}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="Profile" />
                    <Tab label="Payment method" />
                    <Tab label="Security" />
                    <Tab label="Activity" />
                    <Tab label="Subscription" />
                    <Tab label="Branding" />
                    <Tab label="Team" />
                  </Tabs>

                  <TabPanel value={tab} index={0}>
                    <ProfileTab />
                  </TabPanel>
                  <TabPanel value={tab} index={1}>
                    <PaymentMethodTab />
                  </TabPanel>
                  <TabPanel value={tab} index={2}>
                    <SecurityTab />
                  </TabPanel>
                  <TabPanel value={tab} index={3}>
                    <ActivityTab />
                  </TabPanel>
                  <TabPanel value={tab} index={4}>
                    <SubscriptionTab />
                  </TabPanel>
                  <TabPanel value={tab} index={5}>
                    <Suspense fallback={<Typography>Loading branding…</Typography>}>
                      <OrganizationSettings embedMode />
                    </Suspense>
                  </TabPanel>
                  <TabPanel value={tab} index={6}>
                    <Suspense fallback={<Typography>Loading team settings…</Typography>}>
                      <TeamSettings embedMode />
                    </Suspense>
                  </TabPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
